import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";

const Styled = styled(Box, {
  shouldForwardProp: (prop) => prop !== "dialogState",
})(({ theme }) => ({
  "& .gridContainer": {
    padding: "1rem 1.5rem",
    justifyContent: "center",
    position: "relative",
    "& .MuiAlert-icon": { display: "none" },
    "& .MuiCard-root": {
      minHeight: "12.5rem",
      cursor: "pointer",
    },
    "& .MuiCardHeader-root": {
      padding: "0.5rem 0.9375rem 0.5rem 0.75rem",
      "& .MuiTypography-root": {
        fontSize: "1rem",
        fontWeight: 500,
        ...theme.applyStyles("light", { fontWeight: 600 }),
      },
    },
    "& .MuiCardHeader-action": {
      color: "#fff",
      ...theme.applyStyles("light", { color: theme.palette.primary.main }),
    },
    "& .MuiCardContent-root": {
      padding: "0.5rem 0.9375rem",
      verticalAlign: "middle",
    },
    "& .userAddress": {
      wordWrap: "break-word",
    },
    "& .verifyCard": {
      cursor: "pointer",
      wordWrap: "break-word",
      "& .MuiAlert-root": { width: "fit-content", marginTop: "1.5rem" },
    },
  },
  variants: [
    {
      props: ({ dialogState }) => dialogState.selectedItem === 2,
      style: {
        "& .gridContainer": {
          "& .verifyCard": {
            backgroundColor: "#659e36",
            ...theme.applyStyles("light", { backgroundColor: "#c2eaa1" }),
          },
        },
      },
    },
    {
      props: ({ dialogState }) => dialogState.selectedItem !== 2,
      style: {
        "& .gridContainer": {
          "& .verifyCard": {
            "&:hover": {
              backgroundColor: "rgb(39, 142, 35)",
              ...theme.applyStyles("light", { backgroundColor: "#b1e580" }),
            },
          },
        },
      },
    },
    {
      props: ({ dialogState }) => dialogState.selectedItem === 1,
      style: {
        "& .gridContainer": {
          "& .userAddress": {
            backgroundColor: "rgb(39, 142, 35)",
            ...theme.applyStyles("light", { backgroundColor: "#c2eaa1" }),
          },
        },
      },
    },
    {
      props: ({ dialogState }) => dialogState.selectedItem !== 1,
      style: {
        "& .gridContainer": {
          "& .userAddress": {
            "&:hover": {
              backgroundColor: "rgb(39, 142, 35)",
              ...theme.applyStyles("light", { backgroundColor: "#b1e580" }),
            },
          },
        },
      },
    },
    {
      props: ({ dialogState }) => dialogState.isError,
      style: {
        "& .gridContainer": {
          "& .verifyCard": {
            cursor: "default !important",
            "&:hover": {
              backgroundColor: "#121212",
              ...theme.applyStyles("light", {
                backgroundColor: "transparent",
              }),
            },
          },
        },
      },
    },
  ],
}));
export default Styled;
